import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {ANALYTIC_EVENTS, Analytics} from '@chekin/shared';
import {usePath} from 'hooks';
import {Button} from '@chekinapp/ui';

type DiscardIVChangesProps = {
  onClose: () => void;
  resetIVProcess: () => void;
};

function DiscardIVChanges({onClose, resetIVProcess}: DiscardIVChangesProps) {
  const navigate = useNavigate();
  const {getMainPath} = usePath();

  const {t} = useTranslation();
  const discardIVChangesAndReset = React.useCallback(() => {
    Analytics.track(ANALYTIC_EVENTS.ivLeaving);
    resetIVProcess();
    navigate(getMainPath(PATHS.home));
  }, [resetIVProcess, navigate, getMainPath]);

  const discardIVChangesText = React.useMemo(
    () => (
      <Trans i18nKey="discard_iv_changes_text">
        Leaving the process before completing the registration will
        <b>discard the photos</b> uploaded <b>or the data</b> completed so far and you
        will have to start over.
      </Trans>
    ),
    [],
  );

  return (
    <div className="discard-iv-changes-modal flex flex-col gap-8">
      <p className="text-center text-sm text-gray-700">{discardIVChangesText}</p>
      <div className="flex flex-col gap-5 max-w-[375px] mx-auto">
        <Button onClick={discardIVChangesAndReset}>{t('discard_changes_leaving')}</Button>
        <Button variant="link" onClick={onClose}>
          {t('continue_process')}
        </Button>
      </div>
    </div>
  );
}

export {DiscardIVChanges};
